import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PhotographerComponent } from './components/photographer.component';
import { AuthorizationGuardService } from '../../shared/libs/auth/authorization-guard.service';
import { PhotographerOrderList } from './components/photographer-order-list/photographer-order-list';
import { PhotographerOrderDetailComponent } from './components/photographer-order-detail/photographer-order-detail';
import { PhotographerOrderDetailShotsComponent } from './components/photographer-order-detail/photographer-order-detail-shots/photographer-order-detail-shots';
import { PhotographerOrderDetailInfoComponent } from './components/photographer-order-detail/photographer-order-detail-info/photographer-order-detail-info';
import { Roles } from 'src/app/shared/types/role.enum';

const routes: Routes = [
	{
		path: '',
		component: PhotographerComponent,

		children: [
			{
				path: '',
				redirectTo: 'order-list',
				pathMatch: 'full'
			},

			{
				path: 'order-info/order-detail-info/:orderId',
				redirectTo: 'order-view/:orderId/order-detail-info',
				pathMatch: 'full'
			},
			{
				path: 'order-info/order-detail-shots/:orderId',
				redirectTo: 'order-view/:orderId/order-detail-shots',
				pathMatch: 'full'
			},
			{
				path: 'order-list',
				component: PhotographerOrderList,
				data: {
					roles: [Roles.PHOTOGRAPHER]
				},
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'order-view',
				redirectTo: 'order-view/new',
				pathMatch: 'full'
			},
			{
				path: 'order-view/:orderId',
				component: PhotographerOrderDetailComponent,
				data: {
					roles: [Roles.PHOTOGRAPHER]
				},
				canActivate: [AuthorizationGuardService],
				children: [
					{
						path: '',
						redirectTo: 'order-detail-info',
						pathMatch: 'full'
					},
					{
						path: 'order-detail-info',
						component: PhotographerOrderDetailInfoComponent
					},
					{
						path: 'order-detail-shots',
						component: PhotographerOrderDetailShotsComponent
					}
				]
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)]
})
export class PhotographerRouting {}
